<template>
  <div>
    <div class="list">
      <ul class="flex flex-wrap">
        <li
          key="bonus-none"
          class="w-1/2 lg:w-1/4 flex"
        >
          <label
            class="config-btn text-gray-700 mx-1 w-full cursor-pointer mx-2 my-2 md:h-48"
            :class="{'active': chosenBonus.length === 0}"
            @click="clearBonus"
          >
            <NoBonusIcon class="mb-3" />
            <span class="text-xs sm:text-base md:text-lg">{{ $t('order.noBonus') }}</span>
          </label>
        </li>
        <li
          v-for="(bonus, i) in avaibleBonuses"
          :key="`bonus-${i}`"
          class="w-1/2 lg:w-1/4 flex"
        >
          <label
            class="config-btn text-gray-700 mx-1 w-full cursor-pointer mx-2 my-2 md:h-48 relative"
            :class="{'active': chosenBonus.includes(i)}"
          >
            <div
              v-if="bonus.is_novelty"
              class="badge"
            >{{ $t('order.novelty') }}</div>
            <input
              v-model="chosenBonus"
              class="hidden"
              type="checkbox"
              :value="i"
            >
            <img
              class="w-24 mb-3"
              :src="bonus.photo_url"
              :alt="name(bonus)"
            >
            <span class="text-xs sm:text-base md:text-lg">{{ name(bonus) }}</span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import NoBonusIcon from '@/assets/icons/none.svg';
import { mapState, mapMutations, mapGetters } from 'vuex';
import name from '@/mixins/name';

export default {
  name: 'Step4',
  components: {
    NoBonusIcon,
  },
  mixins: [name],
  props: {
    activeStep: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      chosenBonus: [],
    };
  },
  computed: {
    ...mapState('order', ['subcategory_id', 'bonuses']),
    ...mapGetters('order', ['chosenCategoryObj']),
    avaibleBonuses() {
      const obj = {};
      Object.keys(this.bonuses).forEach((bonusName) => {
        if (this.chosenCategoryObj[`can_have_${bonusName}`]) {
          this.$set(obj, bonusName, this.bonuses[bonusName]);
        }
      });

      return obj;
    },
    bonusObj() {
      const bonusObj = {};
      Object.keys(this.bonuses).forEach((bonusName) => {
        if (this.chosenBonus.includes(bonusName)) {
          this.$set(bonusObj, bonusName, true);
        } else {
          this.$set(bonusObj, bonusName, false);
        }
      });

      return bonusObj;
    },
  },
  watch: {
    bonusObj(obj) {
      this.updateBonus(obj);
    },
    subcategory_id() {
      this.clearBonus();
    },
  },
  methods: {
    ...mapMutations('order', ['updateBonus']),
    initStep(num) {
      if (this.activeStep < num) this.$emit('changeStep', num);
    },
    validateOrder() {
      this.initStep(5);
    },
    clearBonus() {
      this.chosenBonus = [];
    },
  },
};
</script>
